import { SVGProps } from 'react';
import { Field } from '@components/dynamic-input-fields/src/dynamic-input-fields.type';
import { InvitationInfoType } from '@components/process-invite-guest/src/process-invite-guest.type';
import { Admission } from '@domain/admission';
import { CompanyRoles } from '@domain/company';
import { Invitation } from '@domain/invitation';

export const INFO_TYPE_FIELD = 'infoType';

export interface InviteGuestFillInfoOption {
  name: string;
  bordered: boolean;
  subtitle: string;
  id: InvitationInfoType;
  icon: (props: SVGProps<SVGSVGElement>) => JSX.Element;
  className: string;
  wrapperClasses: string;
  action: () => void;
}

export interface InviteGuestFillInfoProps {
  onContinue: () => void;
  handleClose: () => void;
  isSubmitting?: boolean;
}

export interface InviteGuestSingleInviteProps {
  options: InviteGuestFillInfoOption[];
  requiredFields: Field[];
  isoCode: string;
}

export interface InviteGuestMultipleInviteProps {
  title: string;
  instructionsTitle: string;
  instructionsDescription: string;
  textareaPlaceholder: string;
  offer?: Admission | Invitation;
  roleName?: CompanyRoles;
}

export interface InviteGuestSelectTypeProps {
  onContinue: () => void;
  offer?: Admission;
}
